import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';




function imprimirEncomenda({
  idVenda,
  dataEntrega,
  saborTorta,
  itens,
  infoPag
}) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const itensTabela = [
    [
      { text: 'Código', style: 'tableHeader' },
      { text: 'Descrição', style: 'tableHeader' },
      { text: 'Qtd', style: 'tableHeader', alignment: 'center' }
    ],
    ...itens.map((item, index) => ([
      {
        text: item.COD_PRODUTO?.toString() || '',
        fillColor: index % 2 === 0 ? '#F8F9FA' : null
      },
      {
        text: item.DESCRICAO || '',
        fillColor: index % 2 === 0 ? '#F8F9FA' : null
      },
      {
        text: item.QTD?.toString() || '',
        alignment: 'center',
        fillColor: index % 2 === 0 ? '#F8F9FA' : null
      }
    ]))
  ];

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [25, 25, 25, 25],

    content: [

      // CABEÇALHO
      {
        table: {
          widths: ['*'],
          body: [[
            {
              text: `PEDIDO #${idVenda}`,
              alignment: 'center',
              fontSize: 22,
              bold: true,
              color: 'white',
              fillColor: '#343A40',
              margin: [0, 10, 0, 10]
            }
          ]]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 15]
      },

      // DADOS DA ENCOMENDA
      {
        columns: [
          {
            width: '*',
            stack: [
              {
                text: 'DATA DE ENTREGA',
                style: 'label'
              },
              {
                text: dataEntrega,
                style: 'value'
              }
            ],
            margin: [0, 0, 10, 0]
          },
          {
            width: '*',
            stack: [
              {
                text: 'SABOR DA TORTA',
                style: 'label'
              },
              {
                text: saborTorta || '-',
                style: 'value'
              }
            ]
          }
        ],
        margin: [0, 0, 0, 20]
      },

      // TÍTULO PRODUTOS
      {
        text: 'ITENS DO PEDIDO',
        style: 'sectionTitle'
      },

      // TABELA
      {
        table: {
          headerRows: 1,
          widths: [90, '*', 50],
          body: itensTabela
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#CCCCCC',
          vLineColor: () => '#CCCCCC'
        },
        margin: [0, 0, 0, 20]
      },

      // PAGAMENTO
      {
        text: 'INFORMAÇÕES DE PAGAMENTO',
        style: 'sectionTitle'
      },

      {
        table: {
          widths: ['*'],
          body: [[
            {
              text: infoPag || 'Nenhuma informação de pagamento.',
              margin: [10, 10, 10, 10]
            }
          ]]
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => '#CCCCCC',
          vLineColor: () => '#CCCCCC'
        }
      }

    ],

    footer: function(currentPage, pageCount) {
      return {
        columns: [
          {
            text: `Impresso em ${new Date().toLocaleString('pt-BR')}`,
            margin: [25, 0, 0, 0],
            fontSize: 8
          },
          {
            text: `${currentPage}/${pageCount}`,
            alignment: 'right',
            margin: [0, 0, 25, 0],
            fontSize: 8
          }
        ]
      };
    },

    styles: {
      label: {
        fontSize: 9,
        bold: true,
        color: '#6C757D'
      },

      value: {
        fontSize: 12,
        bold: true
      },

      sectionTitle: {
        fontSize: 13,
        bold: true,
        margin: [0, 0, 0, 8]
      },

      tableHeader: {
        fillColor: '#343A40',
        color: 'white',
        bold: true,
        margin: [0, 5, 0, 5]
      }
    }
  };

  pdfMake.createPdf(docDefinition).open();
}

export default imprimirEncomenda;